export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/ImageWorker.worker.76555a36a7db223b65f5.worker.js");
}
